import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {BaseViewElement} from '../base-view-element';
import {PropertySet} from '../../../core/model/helper-models/property-set.model';
import {Property} from '../../../core/model/helper-models/property.model';

@Component({
    selector: 'app-time',
    templateUrl: './time.component.html',
    styleUrls: ['./time.component.scss',
        './../card.scss'],
    standalone: false
})
export class TimeComponent extends BaseViewElement implements OnInit, OnChanges
{
    @Input() Distance: PropertySet;
    @Input() TimeGeneral: PropertySet;

    OperationTime: Property<any>;
    DrivingTime: Property<any>;
    WaitTime: Property<any>;
    OffTime: Property<any>;
    TimeBetweenErrors: Property<any>;
    TimeIntoLift: Property<any>;
    TimeIntoRack: Property<any>;
    KmCounterX: Property<any>;
    TelescopeDistance: Property<any>;

    constructor()
    {
        super('time');
    }

    ngOnChanges(changes: SimpleChanges): void
    {
        if (this.Distance != null)
        {
            this.KmCounterX = this.Distance.properties.get('KM_COUNTER_X_AXIS');
            this.TelescopeDistance = this.Distance.properties.get('TELESCOPE_DISTANCE_Z_AXIS');
        }

        if (this.TimeGeneral != null)
        {
            this.OperationTime = this.TimeGeneral.properties.get('OPERATION_TIME');
            this.DrivingTime = this.TimeGeneral.properties.get('DRIVING_TIME');
            this.WaitTime = this.TimeGeneral.properties.get('WAIT_TIME');
            this.OffTime = this.TimeGeneral.properties.get('OFF_TIME');
            this.TimeBetweenErrors = this.TimeGeneral.properties.get('TIME_BETWEEN_ERRORS');
            this.TimeIntoLift = this.TimeGeneral.properties.get('TIME_DRIVE_INTO_LIFT');
            this.TimeIntoRack = this.TimeGeneral.properties.get('TIME_DRIVE_INTO_RACK');
        }
    }

    onResize(result: any)
    {
        this.childResizeEvent.emit();
    }
}
